import React, {Component} from 'react';

class SystemMode extends Component {
	/**
	 * Render the component into html.
	 */
	render () {
		const {className} = this.props;

		return <div {...this.props} className={`icon-system-mode ${className ? className : ''}`}>
			<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="img"
			     viewBox="0 0 48 48">
				<path fill="currentColor"
				      d="M 23.970703 2 A 2.0002 2.0002 0 0 0 22.585938 2.5859375 L 17.171875 8 L 10 8 A 2.0002 2.0002 0 0 0 8 10 L 8 17.171875 L 2.5859375 22.585938 A 2.0002 2.0002 0 0 0 2.5859375 25.414062 L 8 30.828125 L 8 38 A 2.0002 2.0002 0 0 0 10 40 L 17.171875 40 L 22.585938 45.414062 A 2.0002 2.0002 0 0 0 25.414062 45.414062 L 30.828125 40 L 38 40 A 2.0002 2.0002 0 0 0 40 38 L 40 30.828125 L 45.414062 25.414062 A 2.0002 2.0002 0 0 0 45.414062 22.585938 L 40 17.171875 L 40 10 A 2.0002 2.0002 0 0 0 38 8 L 30.828125 8 L 25.414062 2.5859375 A 2.0002 2.0002 0 0 0 23.970703 2 z M 24 6.828125 L 28.585938 11.414062 A 2.0002 2.0002 0 0 0 30 12 L 36 12 L 36 18 A 2.0002 2.0002 0 0 0 36.585938 19.414062 L 41.171875 24 L 36.585938 28.585938 A 2.0002 2.0002 0 0 0 36 30 L 36 36 L 30 36 A 2.0002 2.0002 0 0 0 28.585938 36.585938 L 24 41.171875 L 24 6.828125 z"/>
			</svg>
		</div>;
	}
}

export default SystemMode;
